export class CaseBudgetModel {
    public id: number;
    public budget: string;
    public hours: string;
    public budgetDate: Date;
    public caseId:number;
    public staffId:number;
    public notesJustification:string;
   
}